import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';

class Notifications extends Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.notifications !== nextProps.notifications) {
      this.notification.addNotification(nextProps.notifications);
    }
  }

  render() {
    return (
      <NotificationSystem ref={(notification) => { this.notification = notification; }} style={false} />
    );
  }
}

Notifications.propTypes = {
  notifications: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    notifications: state.notifications,
  };
}

export default connect(mapStateToProps)(Notifications);



// WEBPACK FOOTER //
// ./library/app/components/Global/Notifications/Notifications.js